import { IDropdownOption } from "office-ui-fabric-react";

export enum EllipsisOptions {
    NewDocument,
    Unlock,
    Properties,
}

export interface FilingLocation {
    Percent: number;
    Name: string;
    Path: string;
    Url: string;
    CanFileDirect: boolean;
    ContentLocationId: number;
    ContentLocationTitle: string;
    ContentLocationIsExpandable: boolean;
    IsChildLocation: boolean;
    Metadata: { [key: string]: string };
    StorageType: string;
    AutoMapPath: string;
    AutoMapPlaceholder: string;
    FullPath: string;
    NextPage: string;
    DownloadUrl: string;
    IsFile: boolean;
    UpdateDocumentVersion: boolean;
    SiteUrl: string;
    SpHostKVPrefix: string;
    Shared: boolean;
    ExternalTeamId: string;
    ExternalChannelId: string;
    ChannelType: string;
    DriveId: string;
    TeamsSiteUrl: string;
    CopyFile: boolean;
    InTeams?: string;
    IsUploading: boolean;
}

export enum DMSConfigOptions {
    Immediately = "0",
    Schedule = "1",
    Manually = "2",
}

export interface AppProxyDetails {
    CredentialsSet: boolean;
    ProxyDetails: AppProxy[];
    Username: string;
    Password: string;
}

export interface AllDMSConfigOptions {
    CreatedFilesUpdateDMSOption: DMSConfigOptions;
    CreatedFilesNewVersion: boolean;
    CreatedFilesUseLatestComment: boolean;
    CreatedFilesRemoveFilesOption: DMSConfigOptions;
    CheckedoutFilesUpdateDMSOption: DMSConfigOptions;
    CheckedoutFilesNewVersion: boolean;
    CheckedoutFilesUseLatestComment: boolean;
    CheckedoutFilesRemoveFilesOption: DMSConfigOptions;
    CreatedFilesSyncDelay: string;
    CreatedFilesDeleteDelay: string;
    CheckedoutFilesSyncDelay: string;
    CheckedoutFilesDeleteDelay: string;
    CreateFolderStructure: boolean;
}

export interface PaginatedFilingLocations {
    Page: FilingLocation[];
    PagingToken: PagingToken;
    Errors: DmsErrors;
}

export enum DmsErrors {
    NotLinked = "0",
    ListViewThreshold = "1",
}

export interface PagingToken {
    PagingToken: string;
    Id: number;
    PageSize: number;
    TotalItemCount: number;
}

export interface UploadedFileInfo {
    TeamsUrl: string;
    FileName: string;
    Url: string;
    FileIdInTeams: string;
    DmsFileId: string;
}

export interface CheckoutFolderInfo {
    FolderId: string;
    FolderUrl: string;
    ChannelId: string;
}

export interface DmsSearch {
    CaseName: string;
    DocName: string;
    CaseSearched: boolean;
    DocSearched: boolean;
    TeamsUrl: string;
    Url: string;
    Metadata: { [key: string]: string };
    InitialId: string;
    StorageType: string;
    DeletedFile: boolean;
    Linked: boolean;
    ShowStatus: boolean;
    TeamsDocumentStatus: boolean;
    IsUploading: boolean;
}

export enum MetadataTypes {
    Text,
    Number,
    Lookup,
    Date,
    Note,
    Search,
}

export enum StopSharingOptions {
    NewVersion,
    NewDocument,
    DiscardChanges,
}

export interface MetadataLookupSearchResponse {
    DefaultValuesList: DefaultValues[];
    DropDownOptions: IDropdownOption[];
}

export interface DefaultValues {
    Key: string;
    DefaultValue: string;
}

export type MetadataFields = Partial<KnownMetadataFields> & { [key: string]: string };

export interface KnownMetadataFields {
    Field: string;
    Value: string;
    Type: MetadataTypes;
    Id: string;
    Required: boolean;
    Linked: number;
    Disabled: boolean;
    ErrorMessage: string;
    DropDownOptions: IDropdownOption[];
    ParentKey: string;
    HasAllOptions: boolean;
    DefaultSource: number;
    DefaultValuesList: DefaultValues[];
    ManuallyDisabled: boolean;
}

export interface NetDocumentsUserAuthInfo {
    IsAuthenticated: boolean;
    AuthenticationUrl: string;
}

export interface iManageUserAuthInfo {
    IsAuthenticated: boolean;
    AuthenticationUrl: string;
}

export interface DmsCaseInfo {
    CaseName: string;
    CaseDetails: string;
    UserId: string;
    GraphToken: string;
    StorageType: string;
    LinkedMatterUrl: string;
}

export interface LinkedStorageInfo {
    StorageType: string;
    SPHostKVPrefix: string;
    SiteUrl: string;
}

export interface SharedFile {
    FileName: string;
    SharedBy: string;
    SharedDate: string;
    SharedLocation: string;
    DmsFileId: string;
    ExternalTeamId: string;
    ExternalTeamFileId: string;
    Metadata: MetadataFields;
    UploadedFileUrl: string;
    ExternalFileParentFolderId: string;
    IsDeleted: boolean;
    RecycleBinUrl: string;
    LastModifiedDate: string;
    LastModifiedBy: string;
    ExternalTeamFileName: string;
    IsUploading: boolean;
}

export interface AppProxy {
    Id: string;
    IsNew: boolean;
    AppId: string;
    Username: string;
    Password: string;
    InternalUrl: string;
    ExternalUrl: string;
}

export const dummyLocation: FilingLocation = {
    CanFileDirect: false,
    ContentLocationId: -1,
    ContentLocationIsExpandable: false,
    ContentLocationTitle: "",
    IsChildLocation: false,
    Metadata: {},
    Name: "",
    Path: "",
    Percent: 0,
    Url: "",
    StorageType: "",
    AutoMapPath: "",
    AutoMapPlaceholder: "",
    FullPath: "",
    NextPage: "",
    DownloadUrl: "",
    IsFile: false,
    UpdateDocumentVersion: false,
    SiteUrl: "",
    SpHostKVPrefix: "",
    Shared: false,
    ExternalChannelId: "",
    ExternalTeamId: "",
    ChannelType: "",
    DriveId: "",
    TeamsSiteUrl: "",
    CopyFile: false,
    IsUploading: false,
};

export enum DmsStorageType {
    SharePoint = "sharepoint",
    iManage = "imanage",
    NetDocuments = "netdocuments",
}

export enum TabType {
    Teams,
    Dms,
}

export interface IDetailListColumnProps {
    Key: string;
    MinWidth: number;
}

export interface FilterOption {
    DisplayName: string;
    FieldName: string;
    Value: string;
    IsFolder: boolean;
}

export interface FilterOptionsResponse {
    FilterOptions: FilterOption[];
}

export interface ConfigurationError {
    Error: string;
    Message: string;
    DmsUrl: string;
    LibraryName: string;
}

export enum LinkType {
  Folder = 'folder',
  Workspace = 'workspace',
}